import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth';

export const rolesGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const roles: string[] = route.data['roles'] || [];
  const matchAll: boolean = route.data['matchAll'] || false;

  const hasAccess: boolean = matchAll
    ? roles.every(role => authService.isInRole(role))
    : roles.some(role => authService.isInRole(role));

  if (hasAccess) return true;

  router.navigate(['/unauthorized']);
  return false;
};
